import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  LocationSectorGQL,
  LocationSectorQuery,
  LocationSectorOrderByInput,
  LocationSectorsPaginatedGQL,
  LocationSectorsPaginatedQuery,
} from '@generated/sammathnaur.graphql'
import { firstValueFrom } from 'rxjs'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class LocationsSectorsService {
  public readonly filterForm = new FormGroup({
    locationId: new FormControl(),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<LocationSectorOrderByInput>(LocationSectorOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)

  public readonly locationSectorsPaginatedGQL = inject(LocationSectorsPaginatedGQL)
  public readonly locationSectorGQL = inject(LocationSectorGQL)

  public async searchPage(): Promise<Apollo.QueryResult<LocationSectorsPaginatedQuery>> {
    const { locationId, archived } = this.filterForm.value

    const observable$ = this.locationSectorsPaginatedGQL.fetch({
      variables: {
        where: {
          locationId,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async searchOne(id: string): Promise<Apollo.QueryResult<LocationSectorQuery>> {
    const observable$ = this.locationSectorGQL.fetch({ variables: { id } })
    return firstValueFrom(observable$)
  }
}
